import script from "./TicketView.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketView.vue?vue&type=script&setup=true&lang=js"

import "./TicketView.vue?vue&type=style&index=0&id=27011a38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27011a38"]])

export default __exports__